var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBreadcrumbSeparator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0007 1.83301C5.94065 1.83301 1.83398 5.93967 1.83398 10.9997C1.83398 16.0597 5.94065 20.1663 11.0007 20.1663C16.0607 20.1663 20.1673 16.0597 20.1673 10.9997C20.1673 5.93967 16.0607 1.83301 11.0007 1.83301ZM14.6948 11.4855L11.9448 14.2355C11.8073 14.373 11.6332 14.4372 11.459 14.4372C11.2848 14.4372 11.1107 14.373 10.9732 14.2355C10.7073 13.9697 10.7073 13.5297 10.9732 13.2638L12.5498 11.6872H7.79232C7.41648 11.6872 7.10482 11.3755 7.10482 10.9997C7.10482 10.6238 7.41648 10.3122 7.79232 10.3122H12.5498L10.9732 8.73551C10.7073 8.46967 10.7073 8.02967 10.9732 7.76384C11.239 7.49801 11.679 7.49801 11.9448 7.76384L14.6948 10.5138C14.9607 10.7797 14.9607 11.2197 14.6948 11.4855Z",
    fill: "#EB2019"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreadcrumbSeparator);
export default __webpack_public_path__ + "static/media/breadcrumb-separator.81779f5cd400539a1c83ada02aac558a.svg";
export { ForwardRef as ReactComponent };